import { render } from "./ManagerStatsCharts.vue?vue&type=template&id=6a86220c"
import script from "./ManagerStatsCharts.vue?vue&type=script&lang=js"
export * from "./ManagerStatsCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__